/*
 * @Author: wangsx
 * @Date: 2020-07-29 23:43:30
 * @LastEditTime: 2022-01-17 14:13:17
 * @LastEditors: your name
 * @Description: In User Settings Edit
 */
import { isGloballyWhitelisted } from "@vue/shared";
import { Base64 } from "js-base64";
import moment from "moment";
import {
  urlToBlob,
} from "@/api/smartApplication/personSearchApi.js";
/**
 * JS字符串加密和解密
 * @date:    2018年06月07日 上午10:03:41
 * @author   Senao
 * @param    {[string]} [str] [需要加密/解密的字符串（包括中文）]
 * @param    {[string]} [pwd] [密码]
 * @param    {[string]} [type] [类型：E = 加密 、D = 解密]
 * @return   {[string]}
 */
const secretKey = (str, pwd, type) => {
  var b = Base64; // 需要加载一个Base64.js文件 可以上网自行下载
  if (type === "E") {
    // 加密
    str = b.encode(str); // Base64加密
    var prand = "";
    for (var i = 0; i < pwd.length; i++) {
      prand += pwd.charCodeAt(i).toString();
    }
    var sPos = Math.floor(prand.length / 5);
    var mult = parseInt(
      prand.charAt(sPos) +
      prand.charAt(sPos * 2) +
      prand.charAt(sPos * 3) +
      prand.charAt(sPos * 4) +
      prand.charAt(sPos * 5)
    );
    var incr = Math.ceil(pwd.length / 2);
    var modu = Math.pow(2, 31) - 1;
    if (mult < 2) {
      alert("Please choose a more complex or longer password.");
      return null;
    }
    var salt = Math.round(Math.random() * 1000000000) % 100000000;
    prand += salt;
    while (prand.length > 10) {
      prand = (
        parseInt(prand.substring(0, 10)) +
        parseInt(prand.substring(10, prand.length))
      ).toString();
    }
    prand = (mult * prand + incr) % modu;
    var enc_chr = "";
    var enc_str = "";
    for (let i = 0; i < str.length; i++) {
      enc_chr = parseInt(str.charCodeAt(i) ^ Math.floor((prand / modu) * 255));
      if (enc_chr < 16) {
        enc_str += "0" + enc_chr.toString(16);
      } else enc_str += enc_chr.toString(16);
      prand = (mult * prand + incr) % modu;
    }
    salt = salt.toString(16);
    while (salt.length < 8) salt = "0" + salt;
    enc_str += salt;
    return enc_str;
  }
  if (type === "D") {
    // 解密
    let prand = "";
    for (let i = 0; i < pwd.length; i++) {
      prand += pwd.charCodeAt(i).toString();
    }
    const sPos = Math.floor(prand.length / 5);
    const mult = parseInt(
      prand.charAt(sPos) +
      prand.charAt(sPos * 2) +
      prand.charAt(sPos * 3) +
      prand.charAt(sPos * 4) +
      prand.charAt(sPos * 5)
    );
    const incr = Math.round(pwd.length / 2);
    const modu = Math.pow(2, 31) - 1;
    const salt = parseInt(str.substring(str.length - 8, str.length), 16);
    str = str.substring(0, str.length - 8);
    prand += salt;
    while (prand.length > 10) {
      prand = (
        parseInt(prand.substring(0, 10)) +
        parseInt(prand.substring(10, prand.length))
      ).toString();
    }
    prand = (mult * prand + incr) % modu;
    let enc_chr = "";
    let enc_str = "";
    for (let i = 0; i < str.length; i += 2) {
      enc_chr = parseInt(
        parseInt(str.substring(i, i + 2), 16) ^ Math.floor((prand / modu) * 255)
      );
      enc_str += String.fromCharCode(enc_chr);
      prand = (mult * prand + incr) % modu;
    }
    return b.decode(enc_str);
  }
};

/**
 * @Description: 解析地址栏中的参数
 * @param  key 不传则返回所有参数；传key则返回key值对应的参数，若没有key对应大参数则返回undefined
 */
const analysisUrl = key => {
  var afterUrl = window.location.search.substring(1); // (问号以后的字符串)
  const afterEqual = afterUrl.split("&");
  const datas = {};
  for (const item of afterEqual) {
    const arr = item.split("=");
    datas[arr[0]] = arr[1] || undefined;
  }
  if (key) {
    return datas[key];
  } else {
    return datas;
  }
};

/**
 * 删除当前url中指定参数
 * @param names 数组或字符串
 * @returns {string}
 */
const funcUrlDel = name => {
  var loca = window.location;
  var baseUrl = loca.origin + loca.pathname + "?";
  var query = loca.search.substr(1);
  if (query.indexOf(name) > -1) {
    var obj = {};
    var arr = query.split("&");
    for (var i = 0; i < arr.length; i++) {
      arr[i] = arr[i].split("=");
      obj[arr[i][0]] = arr[i][1];
    }
    delete obj[name];
    var url =
      baseUrl +
      JSON.stringify(obj)
      .replace(/[\"\{\}]/g, "")
      .replace(/\:/g, "=")
      .replace(/\,/g, "&") +
      loca.hash;
    return url;
  }
};

/**
 * 延迟
 * @param {*} time 延迟时间（毫秒）
 * @returns
 */
export const delay = (time = 1000) => {
  return new Promise(function(resolve, reject) {
    setTimeout(function() {
      resolve(true);
    }, time);
  });
};

// 下载文件
export const downFile = (url, fileName) => {
  if (!url) {
    return this.$message.warning("请输入正确的url");
  }
  const a = document.createElement("a");
  const body = document.querySelector("#app");
  body.appendChild(a);
  a.href = url;
  a.style.display = "none";
  a.target = "_blank";
  if (fileName) {
    a.download = fileName;
  }
  a.click();
  body.removeChild(a);
};
// 下载图片文件
export const downImgFile = (url, fileName) => {
  const down = (href) => {
    const fileName = fileName || new Date().getTime();
    const eleLink = document.createElement("a");
    document.body.appendChild(eleLink);
    eleLink.download = fileName;
    eleLink.href = href;
    eleLink.style.display = "none";
    eleLink.target = "_blank";
    eleLink.click();
    document.body.removeChild(eleLink);
  }
  if (url.indexOf("data:image/png;base64,") == 0) {
    down(url)
  } else {
    const newUrl = "/imgApi/?" + url.split("/?")[1];
    urlToBlob(newUrl).then((res) => {
      const blob = new Blob([res], { type: "image/png" });
      const href = window.URL.createObjectURL(blob);
      down(href)
    });
  }
};

// 下载 base64文件
export const downBaseFile = (fileName, content) => {
  const aLink = document.createElement("a");
  const blob = base64ToBlob(content); // new Blob([content]);

  const evt = document.createEvent("HTMLEvents");
  evt.initEvent("click", true, true); // initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
  aLink.download = fileName;
  aLink.href = URL.createObjectURL(blob);

  // aLink.dispatchEvent(evt);
  aLink.click();
};
// base64转blob
export const base64ToBlob = code => {
  const parts = code.split(";base64,");
  const contentType = parts[0].split(":")[1];
  const raw = window.atob(parts[1]);
  const rawLength = raw.length;

  const uInt8Array = new Uint8Array(rawLength);

  for (let i = 0; i < rawLength; ++i) {
    uInt8Array[i] = raw.charCodeAt(i);
  }
  return new Blob([uInt8Array], { type: contentType });
};
// file对象转base64
export const getBase64 = file => {
  return new Promise((res, rej) => {
    let result = ""
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      result = reader.result
    }
    reader.onerror = (error) => {
      rej(error)
    }
    reader.onloadend = () => {
      res(result)
    }
  })
};
// url转base64
export const urlGetBase64 = (url, callback) => {
  var Img = new Image(),
    dataURL = '';
  Img.src = url + "?v=" + Math.random();
  Img.setAttribute("crossOrigin", 'Anonymous')
  Img.onload = function() {
    var canvas = document.createElement("canvas"),
      width = Img.width,
      height = Img.height;
    canvas.width = width;
    canvas.height = height;
    canvas.getContext("2d").drawImage(Img, 0, 0, width, height);
    dataURL = canvas.toDataURL('image/jpeg');
    callback ? callback(dataURL) : null;
  };
};
// 获取图片尺寸
export const getImageSize = (url, callback) => {
  const Img = new Image();
  Img.src = url
  Img.onload = function() {
    const imageSize = {
      width: Img.width,
      height: Img.height
    }
    callback ? callback(imageSize) : null;
  };
};
// 数据字典code转value
export const codeToValue = (obj, dictObj) => {
  for (let foo in dictObj) {
    for (let key in obj) {
      if (foo == key) {
        dictObj[foo].forEach((element) => {
          if (obj[key] == element.code) obj[key + "Dict"] = element.value || null;
        });
      }
    }
  }
};
// 导出
export const exporting = (res, type = "application/vnd.ms-excel") => {
  const fileName = `${+new Date()}.xls`;
  const blob = new Blob([res], {
    type: type,
  });
  if (navigator.msSaveBlob) {
    navigator.msSaveBlob(blob, fileName);
  } else {
    console.log(blob);
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
    URL.revokeObjectURL(link.href);
  }
};
// 防抖函数立即执行
export const debounceNow = (fn, delay) => {
  let timeOut;
  return function() {
    const context = this;
    const args = arguments;
    const callNow = !timeOut;
    if (timeOut) {
      clearTimeout(timeOut);
    }
    timeOut = setTimeout(() => {
      timeOut = null;
    }, delay);
    if (callNow) fn.apply(context, args);
  };
};
// 防抖函数
export const debounce = (fn, delay) => {
  let timeOut;
  return function() {
    const context = this;
    const args = arguments;
    if (timeOut) {
      clearTimeout(timeOut);
    }
    timeOut = setTimeout(() => {
      fn.apply(context, args);
    }, delay);
  };
};
// 去除对象空值
export const deleteObj = obj => {
  const arr = ["", null, undefined];
  for (const i in obj) {
    if (arr.includes(obj[i])) {
      Reflect.deleteProperty(obj, i);
    }
  }
  return obj;
};
// 格式化对象中时间
export const formatTimer = (attribute, format, obj) => {
  for (const key in obj) {
    if (attribute == key) {
      obj[key] = moment(parseInt(obj[attribute])).format(format);
    }
    if (typeof(obj[key]) === 'object') {
      formatTimer(attribute, format, obj[key]);
    }
  }
  return obj;
};
// 格式化返回数据中时间（list中）
export const formatListTime = (arr, format, listObj) => {
  const result = listObj.map(element => {
    arr.forEach(item => {
      for (const key in element) {
        if (key == item) {
          element[key] = moment(parseInt(element[key])).format(format);
        }
      }
    });
    return element;
  });
  return result;
};
// 判断点位在地图绘制区域中
export const isInsidePolygon = (pt, ploy) => {
  for (var c = false, i = -1, l = ploy.length, j = l - 1; ++i < l; j = i)
    ((ploy[i][1] < pt[1] && pt[1] < ploy[j][1]) || (ploy[j][1] <= pt[1] && pt[1] < ploy[i][1])) &&
    (pt[0] < (ploy[j][0] - ploy[i][0]) * (pt[1] - ploy[i][1]) / (ploy[j][1] - ploy[i][1]) + ploy[i][0]) &&
    (c = !c)
  return c
};
/**
 * 颜色混合
 * @param c1 颜色1
 * @param c2 颜色2
 * @param ratio 比值（0-1）
 * @returns 混合颜色
 */
export const colourBlend = (c1, c2, ratio) => {
  ratio = Math.max(Math.min(Number(ratio), 1), 0);
  const r1 = parseInt(c1.substring(1, 3), 16);
  const g1 = parseInt(c1.substring(3, 5), 16);
  const b1 = parseInt(c1.substring(5, 7), 16);
  const r2 = parseInt(c2.substring(1, 3), 16);
  const g2 = parseInt(c2.substring(3, 5), 16);
  const b2 = parseInt(c2.substring(5, 7), 16);
  const r = Math.round(r1 * (1 - ratio) + r2 * ratio);
  const g = Math.round(g1 * (1 - ratio) + g2 * ratio);
  const b = Math.round(b1 * (1 - ratio) + b2 * ratio);
  const r16 = ("0" + (r || 0).toString(16)).slice(-2);
  const g16 = ("0" + (g || 0).toString(16)).slice(-2);
  const b16 = ("0" + (b || 0).toString(16)).slice(-2);
  return "#" + r16 + g16 + b16;
};

/**
 * 将日期转化为时分秒
 */
export const formatHMS = value => {
  if (!value) {
    return "- -";
  }
  const date = new Date(value);
  let MM = date.getMonth() + 1;
  MM = MM < 10 ? "0" + MM : MM;
  let d = date.getDate();
  d = d < 10 ? "0" + d : d;
  let h = date.getHours();
  h = h < 10 ? "0" + h : h;
  let m = date.getMinutes();
  m = m < 10 ? "0" + m : m;
  let s = date.getSeconds();
  s = s < 10 ? "0" + s : s;
  // return MM + '-' + d + ' ' + h + ':' + m + ':' + s
  return h + ":" + m + ":" + s;
};
/**
 * 将日期转化为年月日
 */
export const formatDateYMD = value => {
  if (!value) {
    return "- -";
  }
  const date = new Date(value);
  const y = date.getFullYear();
  let MM = date.getMonth() + 1;
  MM = MM < 10 ? "0" + MM : MM;
  let d = date.getDate();
  d = d < 10 ? "0" + d : d;
  return y + "-" + MM + "-" + d;
};

// 获取当前的日期
export const detaRq = is => {
  const time = new Date().getTime() - 24 * 60 * 60 * 1000 * is;
  const yesday = new Date(time);
  const day =
    yesday.getFullYear() +
    "-" +
    (yesday.getMonth() >= 9 ?
      yesday.getMonth() + 1 :
      "0" + (yesday.getMonth() + 1)) +
    "-" +
    (yesday.getDate() > 9 ? yesday.getDate() : "0" + yesday.getDate());
  const hour =
    yesday.getHours() + ":" + yesday.getMinutes() + ":" + yesday.getSeconds();
  return day + " " + hour;
};
// 将身份证号转日期
export const birthdayFromCardId = IDCard => {
  if (IDCard.split("").length == 18) {
    const year = IDCard.substring(6, 10)
    const mounth = IDCard.substring(10, 12)
    const day = IDCard.substring(12, 14)
    return year + '-' + mounth + '-' + day
  } else if (IDCard.split("").length == 15) {
    const year = IDCard.substring(6, 8)
    const mounth = IDCard.substring(8, 10)
    const day = IDCard.substring(10, 12)
    return '19' + year + '-' + mounth + '-' + day
  }
};
export { secretKey, analysisUrl, funcUrlDel };